import React from 'react';
import { Helmet } from 'react-helmet';
import '../css/documentation_page.css';

const commands = [
  {
    system: 'League Applications',
    active: [
      {
        name: 'Apply Active League',
        command: '/apply-active-league',
        parameters: 'none',
        description: 'Apply to upgrade your league to Active League.',
        prerequisites: 'Must have a registered base league',
      },
      {
        name: 'Apply Base League',
        command: '/apply-base-league',
        parameters: 'none',
        description: 'Apply to register a Base League.',
        prerequisites: 'none',
      },
      {
        name: 'Apply Sponsored League',
        command: '/apply-sponsored-league',
        parameters: 'none',
        description: 'Apply to upgrade your league to Sponsored League.',
        prerequisites: 'none',
      },
    ],
    archived: [],
  },
  {
    system: 'FF & OPG Official Applications',
    active: [
      {
        name: 'Apply for Official',
        command: '/apply-for-official',
        parameters: 'none',
        description: 'Submit an application to become an official.',
        prerequisites: 'none',
      },
      {
        name: 'List Officials',
        command: '/list_officials',
        parameters: 'none',
        description: 'List and log officials with specific roles into Google Sheets.',
        prerequisites: 'none',
      },
      {
        name: 'Officials Status',
        command: '/officials-status',
        parameters: 'none',
        description: 'Check your current grade and requirement.',
        prerequisites: 'none',
      },
    ],
    archived: [],
  },
  {
    system: 'Content Creator Applications',
    active: [
      {
        name: 'Instagram CC Apply',
        command: '/instagram-cc-apply',
        parameters: 'handle - your Instagram username or link',
        description: 'Apply for the Instagram Content Creator role.',
        prerequisites: 'none',
      },
      {
        name: 'TikTok CC Apply',
        command: '/tiktok-cc-apply',
        parameters: 'handle - your TikTok username or link',
        description: 'Apply for the TikTok Content Creator role.',
        prerequisites: 'none',
      },
      {
        name: 'YouTube CC Apply',
        command: '/youtube-cc-apply',
        parameters: 'handle - your YouTube username or link',
        description: 'Apply for the YouTube Content Creator role.',
        prerequisites: 'none',
      },
    ],
    archived: [],
  },
  {
    system: 'Quality & Checks',
    active: [
      {
        name: 'Quality Score',
        command: '/quality-score',
        parameters: 'user - the user to view quality scores of; platform - platform to filter scores by',
        description: 'Find your quality score for this CC season.',
        prerequisites: 'none',
      },
      {
        name: 'Check Reels Account',
        command: '/check-reels-account',
        parameters: 'none',
        description: 'Check your Instagram application status and 3‑week requirement data.',
        prerequisites: 'none',
      },
      {
        name: 'Check TikTok Account',
        command: '/check-tiktok-account',
        parameters: 'none',
        description: 'Check your TikTok application status and 3‑week requirement data.',
        prerequisites: 'none',
      },
      {
        name: 'Check YouTube Account',
        command: '/check-youtube-account',
        parameters: 'none',
        description: 'Check your YouTube application status and 3‑week requirement data.',
        prerequisites: 'none',
      },
    ],
    archived: [],
  },
  {
    system: 'Leaderboards',
    active: [
      {
        name: 'Quality Leaderboard',
        command: '/quality-leaderboard',
        parameters: 'none',
        description: 'Displays the leaderboard for creator quality scores.',
        prerequisites: 'none',
      },
      {
        name: 'CC Streak Leaderboard',
        command: '/cc-streak-leaderboard',
        parameters: 'none',
        description: 'Displays the leaderboard for active CCs\' posting streaks.',
        prerequisites: 'none',
      },
      {
        name: 'FF Leaderboard',
        command: '/ff-leaderboard',
        parameters: 'category - category to display the leaderboard for',
        description: 'Displays the leaderboard for the specified category.',
        prerequisites: 'none',
      },
      {
        name: 'Playoffs Leaderboard',
        command: '/playoffs_leaderboard',
        parameters: 'none',
        description: 'Displays the event playoff leaderboard based on normalized score.',
        prerequisites: 'none',
      },
      {
        name: 'Content Squad Leaderboard',
        command: '/content-squad-leaderboard',
        parameters: 'mode - choose the leaderboard mode',
        description: 'Displays the content squad leaderboard based on total posts.',
        prerequisites: 'none',
      },
      {
        name: 'Comp Squad Leaderboard',
        command: '/comp-squad-leaderboard',
        parameters: 'none',
        description: 'Displays the competitive squad leaderboard based on total wins since squad creation.',
        prerequisites: 'none',
      },
    ],
    archived: [],
  },
  {
    system: 'Squad Management',
    active: [
      {
        name: 'Change Squad Name',
        command: '/change-squad-name',
        parameters: 'new-name - the new name for your squad (1-4 alphanumeric chars)',
        description: 'Change the name of your squad if you are the squad leader.',
        prerequisites: 'none',
      },
      {
        name: 'Squad Status',
        command: '/squad-status',
        parameters: 'status - choose whether your squad is Open or Closed',
        description: 'Set your squad\'s open/closed status (Squad Leaders only).',
        prerequisites: 'none',
      },
      {
        name: 'Mascot Register',
        command: '/mascot_register',
        parameters: 'none',
        description: 'Register your squad for the mascot event (Squad Leaders only).',
        prerequisites: 'none',
      },
      {
        name: 'Disband Squad',
        command: '/disband-squad',
        parameters: 'none',
        description: 'Disband your squad if you are the squad leader.',
        prerequisites: 'none',
      },
      {
        name: 'Force Disband',
        command: '/force-disband',
        parameters: 'squad-name - the name of the squad to disband',
        description: 'Force disband a squad by its name (Mods only).',
        prerequisites: 'none',
      },
      {
        name: 'Force Squad Name',
        command: '/force-squad-name',
        parameters: 'squad - current squad name; new-name - new name for the squad (1-4 alphanumeric chars)',
        description: 'Forcefully change the name of a squad (Mods only).',
        prerequisites: 'none',
      },
      {
        name: 'Invite to Squad',
        command: '/invite-to-squad',
        parameters: 'member - the member you want to invite',
        description: 'Invite a member to join your squad (Squad Leaders only).',
        prerequisites: 'none',
      },
      {
        name: 'Join Random Squad',
        command: '/join-random-squad',
        parameters: 'none',
        description: 'Attempt to join a random squad that is currently open.',
        prerequisites: 'none',
      },
      {
        name: 'Leave Squad',
        command: '/leave-squad',
        parameters: 'none',
        description: 'Leave your current squad.',
        prerequisites: 'none',
      },
      {
        name: 'Squads',
        command: '/squads',
        parameters: 'none',
        description: 'Lists all registered squads and their owners.',
        prerequisites: 'none',
      },
      {
        name: 'Find Squad Members',
        command: '/find-squad-members',
        parameters: 'none',
        description: 'Create a post to find members for your squad.',
        prerequisites: 'none',
      },
      {
        name: 'Disband Squad (Old)',
        command: '/disband-squad',
        parameters: 'none',
        description: 'Legacy squad disband command.',
        prerequisites: 'none',
      },
    ],
    archived: [],
  },
  {
    system: 'Room Management',
    active: [
      {
        name: 'Room',
        command: '/room',
        parameters: 'view, rename, invite, uninvite, host, mute, unmute, lock, unlock, kick, block, unblock, list, clean',
        description: 'Manage your private room with various subcommands.',
        prerequisites: 'none',
      },
    ],
    archived: [],
  },
  {
    system: 'Misc Tools',
    active: [
      {
        name: 'List Commands',
        command: '/list-cmd',
        parameters: 'none',
        description: 'Lists all available commands and their descriptions.',
        prerequisites: 'none',
      },
      {
        name: 'Increment Round',
        command: '/increment-round',
        parameters: 'none',
        description: 'Increments the current event round number (Moderators only).',
        prerequisites: 'none',
      },
      {
        name: 'Refresh Host Sheet',
        command: '/refresh-host-sheet',
        parameters: 'none',
        description: 'Refreshes the Discord Host sheet for the new week.',
        prerequisites: 'none',
      },
      {
        name: 'Report Player',
        command: '/report-player',
        parameters: 'username - username of the player; rule-broken - rule broken; proof - attach proof',
        description: 'Report a player who has broken the rules.',
        prerequisites: 'none',
      },
      {
        name: 'Top TB Applicants',
        command: '/top-tb-applicants',
        parameters: 'none',
        description: 'Fetch the top 10 applicants based on rules, response, and rep.',
        prerequisites: 'none',
      },
    ],
    archived: [],
  },
];

export default function DocumentationPage() {
  return (
    <>
      <Helmet>
        <title>Documentation - Ballhead</title>
        <meta property="og:title" content="Ballhead Documentation" key="og:title" />
        <meta property="og:description" content="Learn about Ballhead commands and features." key="og:description" />
        <meta property="og:image" content="https://cdn.ballhead.app/web_assets/logo.png" key="og:image" />
        <meta property="og:url" content={`${window.location.origin}/documentation`} key="og:url" />
        <meta property="og:type" content="website" key="og:type" />
        <meta name="twitter:card" content="summary_large_image" key="twitter:card" />
        <meta name="twitter:title" content="Ballhead Documentation" key="twitter:title" />
        <meta name="twitter:description" content="Learn about Ballhead commands and features." key="twitter:description" />
        <meta name="twitter:image" content="https://cdn.ballhead.app/web_assets/logo.png" key="twitter:image" />
      </Helmet>
    <div className="doc-container">
      <section className="systems">
        <h2>Active Systems</h2>
        {commands.map((sys) => (
          <div key={sys.system} className="system-block">
            <h3>{sys.system}</h3>
            {sys.active.map((cmd) => (
              <div key={cmd.name} className="command-card">
                <div className="cmd-info">
                  <strong>{cmd.name}</strong>
                  <p className="cmd-desc">{cmd.description}</p>
                  <p>Command: <code>{cmd.command}</code></p>
                  {cmd.parameters !== 'none' && (
                    cmd.parameters.includes(' - ') ? (
                      <p>
                        Parameters:&nbsp;
                        <code>{cmd.parameters.split(' - ')[0]}</code> - {cmd.parameters.split(' - ')[1]}
                      </p>
                    ) : (
                      <p>Parameters: {cmd.parameters}</p>
                    )
                  )}
                  {cmd.prerequisites !== 'none' && (
                    <p>
                      Prerequisites:&nbsp;
                      <code>{cmd.prerequisites}</code>
                    </p>
                  )}
                </div>
                <img
                  src={`https://cdn.ballhead.app/web_assets/demos/${cmd.name.replace(/\s+/g, '-').toLowerCase()}.gif`}
                  alt={`${cmd.name} demo`}
                  className="demo-img"
                  onError={(e) => { e.currentTarget.style.display = 'none'; }}
                />
              </div>
            ))}
          </div>
        ))}
      </section>

      <section className="systems archived">
        <h2>Archived Systems</h2>
        {commands.map((sys) => (
          <div key={sys.system} className="system-block">
            <h3>{sys.system}</h3>
            {sys.archived.map((cmd) => (
              <div key={cmd.name} className="command-card">
                <div className="cmd-info">
                  <strong>{cmd.name}</strong>
                  <p className="cmd-desc">{cmd.description}</p>
                  <p>Command: <code>{cmd.command}</code></p>
                  {cmd.parameters !== 'none' && (
                    cmd.parameters.includes(' - ') ? (
                      <p>
                        Parameters:&nbsp;
                        <code>{cmd.parameters.split(' - ')[0]}</code> - {cmd.parameters.split(' - ')[1]}
                      </p>
                    ) : (
                      <p>Parameters: {cmd.parameters}</p>
                    )
                  )}
                  {cmd.prerequisites !== 'none' && (
                    <p>
                      Prerequisites:&nbsp;
                      <code>{cmd.prerequisites}</code>
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        ))}
      </section>
    </div>
    </>
  );
}
